import React, { useState } from 'react';

function Slider(props) {
    const [dataLogo] = useState([
        {
            id: 1,
            name: 'PRE-SALES STARTING SOON'
        },
        {
            id: 2,
            name: 'SIGN-UP'
        },
        {
            id: 3,
            name: 'PRE-SALES STARTING SOON'
        },
        {
            id: 4,
            name: 'SIGN-UP'
        },
        {
            id: 5,
            name: 'PRE-SALES STARTING SOON'
        },
        {
            id: 6,
            name: 'SIGN-UP'
        },
        {
            id: 7,
            name: 'PRE-SALES STARTING SOON'
        },
        {
            id: 8,
            name: 'SIGN-UP'
        },
        {
            id: 9,
            name: 'PRE-SALES STARTING SOON'
        },
        {
            id: 10,
            name: 'SIGN-UP'
        },
    ])
    return (
        <section className="logo-slider" style={{ height: "80px", display: "flex", alignItems: "center", backgroundColor: "black" }}>
            <div className="logo-slider-wrap" style={{ backgroundColor: "black" }}>
                <div className="logo-slider-inner">
                    {
                        dataLogo.map((idx, index) => (
                            <h3 className='f-w-700' style={{ fontSize:"25px",color: index % 2 === 0 ? "#92D050" : "white" }} key={idx.id}>{idx.name}</h3>
                        ))
                    }
                </div>
                <div className="logo-slider-inner style-2">
                    {
                        dataLogo.map((idx, index) => (
                            <h3 className='f-w-700' style={{ fontSize:"25px",color: index % 2 === 0 ? "#92D050" : "white" }} key={idx.id}>{idx.name}</h3>
                        ))
                    }
                </div>
            </div>

        </section>
    );
}

export default Slider;